import { IconFn, IconSvg } from "../createIcon";

export const InfoSolidIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 42, height: 42 }} {...props}>
    <path
      d="M0 2C0 0.89543 0.895431 0 2 0H40C41.1046 0 42 0.895431 42 2V40C42 41.1046 41.1046 42 40 42H2C0.89543 42 0 41.1046 0 40V2Z"
      fill={color}
    />
    <path d="M23.1547 30.752H19.0013V20.3301H23.1547V30.752Z" fill="white" />
    <path d="M23.1621 16.1621L19.0004 16.1621V12H23.1621V16.1621Z" fill="white" />
  </IconSvg>
);
